import { render, staticRenderFns } from "./SellerData.vue?vue&type=template&id=205f2cee"
import script from "./SellerData.vue?vue&type=script&lang=js"
export * from "./SellerData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports